import { render, staticRenderFns } from "./ricercaEsterna.vue?vue&type=template&id=066735d4"
import script from "./ricercaEsterna.vue?vue&type=script&lang=js"
export * from "./ricercaEsterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports